function LogoutButton(props) {
  return (
    <button className="logout-btn" onClick={props.onClick}>
      Sign Out
    </button>
  );
}
export default LogoutButton;